import { IMetadata } from '../../interfaces/common';
import { getApiCached } from '../../utils/api';

export interface IFollowUpReason extends IMetadata {
  followUpReasonId: number;
  followUpReasonDescription: string;
}

export const getFollowUpReasons = () =>
  getApiCached<IFollowUpReason[]>('lookup/followupreasons');
